module.exports = __webpack_public_path__ + "media/images/sport--skeleton-d5d03b6e72c49dcf839e4a83ced6f3eb.png";